import {useMemo} from 'react';
import {useSelector} from 'react-redux';

import reduxSelectors from '../../redux/selectors';
import {SingleMultiSelect, SingleMultiSelectProps} from './SingleMultiSelect';

type Props = Omit<SingleMultiSelectProps, 'options'> & {
  layer?: number | null;
  maxDefaultWidth?: number | null;
};

export const ZonesSelect = (props: Props) => {
  const assets = useSelector(reduxSelectors.assets.getAssets);

  const options = useMemo(() => {
    if (props.layer) {
      return assets.zones
        .filter((el) => el.layer_id === props.layer)
        .map((z) => ({id: z.id, name: z.name}));
    } else {
      return assets.zones.map((z) => ({id: z.id, name: z.name}));
    }
  }, [assets, props.layer]);

  const label = props.label ?? 'Sections';
  const nullLabel = props.nullLabel ?? 'All Sections';

  return (
    <SingleMultiSelect
      {...props}
      label={label}
      nullLabel={nullLabel}
      options={options}
    />
  );
};
